import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

//Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import Resources from "@/pages/Dashboard/Resources.vue";


//Pages

import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";

//Accounts
import User from "@/pages/Dashboard/Account/User.vue";

import Mylearning from "@/pages/Dashboard/Mylearning/index.vue";

import Vip from "@/pages/Dashboard/Account/Vip.vue";
import Password from "@/pages/Dashboard/Account/Password.vue";
import Login from "@/pages/Dashboard/Account/Login.vue";
import Register from "@/pages/Dashboard/Account/Register.vue";
import Lock from "@/pages/Dashboard/Account/Lock.vue";
import UserAdmin from "@/pages/Dashboard/Account/UserAdmin.vue";

//Libs
import RoleLib from "@/pages/Dashboard/Lib/RoleLib/RoleLib.vue";
import ToolLib from "@/pages/Dashboard/Lib/ToolLib/ToolLib.vue";
import ToolLibNew from "@/pages/Dashboard/Lib/ToolLib/Action/ToolLibNew.vue";
import SceneLib from "@/pages/Dashboard/Lib/SceneLib/SceneLib.vue";
import DeviceLib from "@/pages/Dashboard/Lib/DeviceLib/DeviceLib.vue";
import ResourceLib from "@/pages/Dashboard/Lib/Resource/ResourceLib.vue";
//Mods
import RoleMod from "@/pages/Dashboard/Mod/RoleMod/RoleMod.vue";
import NewRoleMod from "@/pages/Dashboard/Mod/RoleMod/NewRoleMod.vue";

import SceneMod from "@/pages/Dashboard/Mod/SceneMod/SceneMod.vue";
import NewSceneMod from "@/pages/Dashboard/Mod/SceneMod/NewSceneMod.vue";

import SystemMod from "@/pages/Dashboard/Mod/SystemMod/SystemMod.vue";
import NewSystemMod from "@/pages/Dashboard/Mod/SystemMod/NewSystemMod.vue";

import ToolMod from "@/pages/Dashboard/Mod/ToolMod/ToolMod.vue";
import NewToolMod from "@/pages/Dashboard/Mod/ToolMod/NewToolMod.vue";

import DeviceMod from "@/pages/Dashboard/Mod/DeviceMod/DeviceMod.vue";
import NewDeviceMod from "@/pages/Dashboard/Mod/DeviceMod/NewDeviceMod.vue";

// Class
import SimClass from "@/pages/Dashboard/Class/SimClass.vue";
import SimClassDetails from "@/pages/Dashboard/Class/SimClassDetails.vue";
// import ceshiDemo from "@/pages/Dashboard/Class/ceshiDemo.vue";
import SimClassDetail from "@/pages/Dashboard/Class/SimClassDetail.vue";
import SimProject from "@/pages/Dashboard/Class/SimProject.vue";
import SimProjectDetail from "@/pages/Dashboard/Class/SimProjectDetail.vue";
import SimTask from "@/pages/Dashboard/Class/SimTask.vue";
import SimTaskDetail from "@/pages/Dashboard/Class/SimTaskDetail.vue";

// Nodes
// import Course from "@/pages/Dashboard/Node/Course.vue";
import NewCourse from "@/pages/Dashboard/Node/NewCourse.vue";
import NewResources from "@/pages/Dashboard/Node/NewResources.vue";


import Project from "@/pages/Dashboard/Node/Project.vue";
import NewProject from "@/pages/Dashboard/Node/NewProject.vue";
import Task from "@/pages/Dashboard/Task/Task.vue";
import NewTask from "@/pages/Dashboard/Task/NewTask.vue";

// Resource
import ResourceLibrary from '@/pages/Dashboard/Resource/ResourceLibrary.vue'

// Metas
import NewToolMeta from "@/pages/Dashboard/Meta/ToolMeta/NewToolMeta.vue";
import ToolMeta from "@/pages/Dashboard/Meta/ToolMeta/ToolMeta.vue";
import SystemMeta from "@/pages/Dashboard/Meta/SystemMeta/SystemMeta.vue";
import NewSystemMeta from "@/pages/Dashboard/Meta/SystemMeta/NewSystemMeta.vue";
import SceneMeta from "@/pages/Dashboard/Meta/SceneMeta/SceneMeta.vue";
import NewSceneMeta from "@/pages/Dashboard/Meta/SceneMeta/NewSceneMeta.vue";
import RoleMeta from "@/pages/Dashboard/Meta/RoleMeta/RoleMeta.vue";
import NewRoleMeta from "@/pages/Dashboard/Meta/RoleMeta/NewRoleMeta.vue";
import DeviceMeta from "@/pages/Dashboard/Meta/DeviceMeta/DeviceMeta.vue";
// import DeviceProperty from "@/pages/Dashboard/Meta/DeviceMeta/DeviceProperty.vue";

//Factory
import ApplyMod from "@/pages/Dashboard/Factory/ApplyMod/ApplyMod.vue";
import AuditMod from "@/pages/Dashboard/Factory/AuditMod/AuditMod.vue";
import DevMod from "@/pages/Dashboard/Factory/DevMod/DevMod.vue";
import Demand from "@/pages/Dashboard/Factory/DevMod/Demand.vue";
// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";


// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

// ------------------------------数据服务------------------------------
// 数据概括
import DataSummary from "@/pages/Dashboard/DataService/dataSummary/index.vue";
import CourseDataTable from "@/pages/Dashboard/DataService/dataSummary/courseDataTable.vue";
import StudyDataTable from "@/pages/Dashboard/DataService/dataSummary/studyDataTable.vue";
import ExamDataTable from "@/pages/Dashboard/DataService/dataSummary/examDataTable.vue";

// 学习力数据管理
import LearningAbilityData from "@/pages/Dashboard/DataService/learningAbilityData/index.vue";
import LearningAbilityIndex from "@/pages/Dashboard/DataService/learningAbilityData/learningAbilityIndex.vue";
import LearningAbilitySurvey from "@/pages/Dashboard/DataService/learningAbilityData/learningAbilitySurvey.vue";
import CreateQuestionnaire from "@/pages/Dashboard/DataService/learningAbilityData/createQuestionnaire.vue";


// 知识图谱数据库
import KnowledgeGraph from "@/pages/Dashboard/DataService/knowledgeGraph/index.vue";

// 数字化教学设计评估
import DigitalTeachingDesign from "@/pages/Dashboard/DataService/digitalTeachingDesign/index.vue";
import DigitalAllData from "@/pages/Dashboard/DataService/digitalTeachingDesign/digitalAllData.vue";

// 信息加工有效性评估
import InfoProcessing from "@/pages/Dashboard/DataService/infoProcessing/index.vue";
import InfoAllData from "@/pages/Dashboard/DataService/infoProcessing/infoAllData.vue";

let DataServiceMenu = {
  path: "/dataService",
  component: DashboardLayout,
  name: "DataService",
  children: [
    // 数据概括
    {
      path: "/dataSummary",
      name: "DataSummary",
      component: DataSummary,
    },
    {
      path: "/courseDataTable",
      name: "CourseDataTable",
      component: CourseDataTable,
    },
    {
      path: "/studyDataTable",
      name: "StudyDataTable",
      component: StudyDataTable,
    },
    {
      path: "/examDataTable",
      name: "ExamDataTable",
      component: ExamDataTable,
    },
    // 学习力数据管理
    {
      path: "/learningAbilityData",
      name: "LearningAbilityData",
      component: LearningAbilityData,
    },
    {
      path: "/learningAbilityIndex",
      name: "LearningAbilityIndex",
      component: LearningAbilityIndex,
    },
    {
      path: "/learningAbilitySurvey",
      name: "LearningAbilitySurvey",
      component: LearningAbilitySurvey,
    },
    {
      path: "/createQuestionnaire",
      name: "CreateQuestionnaire",
      component: CreateQuestionnaire,
    },

    // 知识图谱数据库
    {
      path: "/knowledgeGraph",
      name: "KnowledgeGraph",
      component: KnowledgeGraph,
    },
    // 数字化教学设计评估
    {
      path: "/digitalTeachingDesign",
      name: "DigitalTeachingDesign",
      component: DigitalTeachingDesign,
    },
    {
      path: "/digitalAllData",
      name: "DigitalAllData",
      component: DigitalAllData,
    },
    // 信息加工有效性评估
    {
      path: "/infoProcessing",
      name: "InfoProcessing",
      component: InfoProcessing,
    },
    {
      path: "/infoAllData",
      name: "InfoAllData",
      component: InfoAllData,
    },
  ],
};


let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons },
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem },
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels },
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert },
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications },
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons },
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography },
    },
  ],
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms },
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms },
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms },
    },
  ],
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables },
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables },
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables },
    },
  ],
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps },
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true,
      },
      components: { default: FullScreenMap },
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps },
    },
  ],
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/user",
  children: [
    {
      path: "/user",
      name: "User",
      components: { default: User },
    },
    {
      path: "/mylearning",
      name: "Mylearning",
      components: { default: Mylearning },
    },
    {
      path: "/vip",
      name: "Vip",
      components: { default: Vip },
    },
    {
      path: "/password",
      name: "Password",
      component: Password,
    },
    {
      path: "/useradmin",
      name: "UserAdmin",
      component: UserAdmin,
    },
    {
      path: "/userGroup",
      name: "UserGroup",
      component: () => import("@/pages/Dashboard/System/UserGroup/UserGroup.vue"),
    },
    {
      path: "/userGroupEdit",
      name: "UserGroupEdit",
      component: () => import("@/pages/Dashboard/System/UserGroup/Action/Edit.vue"),
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine },
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true,
      },
      components: { default: RtlSupport },
    },
  ],
};

let metasMenu = {
  path: "/",
  component: DashboardLayout,
  name: "Metas",
  children: [
    {
      path: "design",
      name: "design",
      components: { default: () => import('@/pages/DesignPage/CourseList.vue') },
    },
    {
      path: "thirdPartySoft",
      name: "thirdPartySoft",
      components: { default: () => import('@/pages/DesignPage/ThirdPartySoft/index.vue') },
    },
    {
      path: "thirdPartySoft/:id",
      name: "thirdPartySoftModify",
      components: { default: () => import('@/pages/DesignPage/ThirdPartySoft/components/AddAndModifyCard.vue') },
    },
    {
      path: "designDetail",
      name: "designDetail",
      components: { default: () => import('@/pages/DesignPage/index.vue') },
    },
    {
      path: "designContent",
      name: "designContent",
      components: { default: () => import('@/pages/DesignPage/index.vue') },
    },
    {
      path: "taskFlow/:id",
      name: "taskFlow",
      components: { default: () => import('@/pages/DesignPage/Main/Action/TaskFlow/NewTaskFlow.vue') },
    },
    {
      path: "formwork",
      name: "formwork",
      components: { default: () => import('@/pages/Dashboard/Account/Formwork.vue') },
    },
    {
      path: "NewFormWork",
      name: "NewFormWork",
      components: { default: () => import('@/pages/Dashboard/Account/NewFormWork.vue') },
    },
    {
      path: "simclass",
      name: "SimClass",
      components: { default: SimClass },
    },
    {
      path: "simClassDetails",
      name: "SimClassDetails",
      components: { default: SimClassDetails },
    },
    // {
    //   path: "ceshiDemo",
    //   name: "ceshiDemo",
    //   components: { default: ceshiDemo },
    // },
    {
      path: "simclassdetail",
      name: "SimClassDetail",
      components: { default: SimClassDetail },
    },
    {
      path: "simproject",
      name: "SimProject",
      components: { default: SimProject },
    },
    {
      path: "simprojectdetail",
      name: "SimProjectDetail",
      components: { default: SimProjectDetail },
    },
    {
      path: "simtask",
      name: "SimTask",
      components: { default: SimTask },
    },
    {
      path: "simtaskdetail",
      name: "SimTaskDetail",
      components: { default: SimTaskDetail },
    },
    // {
    //   path: "course",
    //   name: "Course",
    //   components: { default: Course },
    // },
    {
      path: "newcourse",
      name: "NewCourse",
      components: { default: NewCourse },
    },
    {
      path: "newresources",
      name: "NewResources",
      components: { default: NewResources },
    },
    {
      path: "project",
      name: "Project",
      components: { default: Project },
    },
    {
      path: "newproject",
      name: "NewProject",
      components: { default: NewProject },
    },
    {
      path: "resourceLibrary",
      name: "ResourceLibrary",
      components: { default: ResourceLibrary },
    },
    {
      path: "newsystemmeta",
      name: "NewSystemMeta",
      components: { default: NewSystemMeta },
    },
    {
      path: "newrolemeta",
      name: "NewRoleMeta",
      components: { default: NewRoleMeta },
    },
    {
      path: "newscenemeta",
      name: "NewSceneMeta",
      components: { default: NewSceneMeta },
    },
    {
      path: "scenemod",
      name: "SceneMod",
      components: { default: SceneMod },
    },
    {
      path: "newscenemod",
      name: "NewSceneMod",
      components: { default: NewSceneMod },
    },
    {
      path: "systemmod",
      name: "SystemMod",
      components: { default: SystemMod },
    },
    {
      path: "newsystemmod",
      name: "NewSystemMod",
      components: { default: NewSystemMod },
    },
    {
      path: "roleLib",
      name: "",
      components: { default: RoleLib },
      props: { default: { type: "role" } },
    },
    {
      path: "toolLib",
      name: "",
      components: { default: ToolLib },
      props: { default: { type: "toollibnew" } },
    },
    {
      path: "toolLibNew",
      name: "",
      components: { default: ToolLibNew },
      props: { default: { type: "toollibnew" } },
    },
    {
      path: "sceneLib",
      name: "",
      components: { default: SceneLib },
    },
    {
      path: "deviceLib",
      name: "",
      components: { default: DeviceLib },
    },
    {
      path: "resourceLib",
      name: "",
      components: { default: ResourceLib },
    },
    {
      path: "rolemod",
      name: "RoleMod",
      components: { default: RoleMod },
    },
    {
      path: "newrolemod",
      name: "NewRoleMod",
      components: { default: NewRoleMod },
    },
    {
      path: "toolmod",
      name: "ToolMod",
      components: { default: ToolMod },
    },
    {
      path: "newtoolmod",
      name: "NewToolMod",
      components: { default: NewToolMod },
    },
    {
      path: "toolmeta",
      name: "ToolMeta",
      components: { default: ToolMeta },
    },
    {
      path: "devicemod",
      name: "DeviceMod",
      components: { default: DeviceMod },
    },
    {
      path: "newdevicemod",
      name: "NewDeviceMod",
      components: { default: NewDeviceMod },
    },
    {
      path: "newtoolmeta",
      name: "NewToolMeta",
      components: { default: NewToolMeta },
    },
    {
      path: "/systemmeta",
      name: "SystemMeta",
      components: { default: SystemMeta },
    },
    {
      path: "/scenemeta",
      name: "SceneMeta",
      components: { default: SceneMeta },
    },
    {
      path: "/rolemeta",
      name: "RoleMeta",
      components: { default: RoleMeta },
    },
    {
      path: "/devicemeta",
      name: "DeviceMeta",
      components: { default: DeviceMeta },
    },
    {
      path: "/applymod",
      name: "ApplyMod",
      components: { default: ApplyMod },
    },
    {
      path: "/auditmod",
      name: "AuditMod",
      components: { default: AuditMod },
    },
    {
      path: "/applycomplie",
      name: "Applycomplie",
      components: { default: () => import("@/pages/DesignPage/Version/apply/index.vue") },
    },
    {
      path: "/auditcompile",
      name: "Auditcompile",
      components: { default: () => import("@/pages/DesignPage/Version/audit/index.vue") },
    },
    {
      path: "/libList",
      name: "libList",
      components: { default: () => import("@/pages/DesignPage/Version/lib/index.vue") },
    },
  
    {
      path: "/demand",
      name: "Demand",
      components: { default: Demand },
    },
    {
      path: "/devmod",
      name: "DevMod",
      components: { default: DevMod },
    },
    {
      path: "/task",
      name: "Task",
      components: { default: Task },
    },
    {
      path: "/newtask",
      name: "NewTask",
      components: { default: NewTask },
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
    },

    {
      path: "/lock",
      name: "Lock",
      component: Lock,
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Home",
  },
  {
    path: "/editor/:courseId/:editorId/:token",
    name: "editor",
    components: { default: () => import('@/pages/DesignPage/editor.vue') },
  },
  {
    path: "/vote/cover",
    name: "voteCover",
    components: { default: () => import('@/pages/DesignPage/Vote/Cover.vue') },
  },
  {
    path: "/vote/question",
    name: "voteQuestion",
    components: { default: () => import('@/pages/DesignPage/Vote/Question.vue') },
  },
  {
    path: "/projectGraphView/:projectId",
    name: "projectGraphView",
    components: { default: () => import('@/pages/DesignPage/ProjectGraphView.vue') },
  },

  {
    path: "/tag",
    name: "tag",
    component: DashboardLayout,
    children: [
      {
        path: "/tag",
        name: "tag",
        components: { default: () => import('@/pages/DesignPage/Tag.vue') },
      }
    ]
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  metasMenu,
  authPages,
  DataServiceMenu,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "",
        components: { default: Dashboard },
      },
      {
        path: "resources",
        name: "",
        components: { default: Resources },
      },
      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar },
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts },
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets },
      },
    ],
  },
];

export default routes;
